type ImageStrategy = {
  component: 'NextImage' | 'OptimizedImage';
  priority: boolean;
  loading: 'eager' | 'lazy';
  sizes: string;
};

export const getImageStrategy = (context: {
  isAboveFold: boolean;
  isLCP: boolean;
  isCritical: boolean;
  itemCount?: number;
  index?: number;
}): ImageStrategy => {
  const { isAboveFold, isLCP, isCritical, itemCount = 0, index = 0 } = context;

  // LCP image - en yüksek priority
  if (isLCP) {
    return {
      component: 'NextImage',
      priority: true,
      loading: 'eager',
      sizes: '100vw',
    };
  }

  // Critical above-the-fold images
  if (isCritical || isAboveFold) {
    return {
      component: 'NextImage',
      priority: true,
      loading: 'eager',
      sizes: '(max-width: 768px) 100vw, 50vw',
    };
  }

  // İlk birkaç ürün - hybrid approach
  if (itemCount > 10 && index < 6) {
    return {
      component: 'NextImage',
      priority: index < 3, // İlk 3'ü priority
      loading: index < 3 ? 'eager' : 'lazy',
      sizes: '(max-width: 768px) 50vw, 25vw',
    };
  }

  // Çok sayıda image - OptimizedImage kullan
  if (itemCount > 10) {
    return {
      component: 'OptimizedImage',
      priority: false,
      loading: 'lazy',
      sizes: '(max-width: 768px) 50vw, 25vw',
    };
  }

  // Default - Normal lazy loading
  return {
    component: 'NextImage',
    priority: false,
    loading: 'lazy',
    sizes: '(max-width: 768px) 100vw, 50vw',
  };
};
